import { HELIXOPS_EMAIL_DOMAIN } from '../Constants/emailMigration';
import { partnerRoleService } from '../Pages/Dashboard/PartnerPortal/Services/partnerRoleService';

const EMPLOYEE_NAVIGATOR_HELIX_USER_TYPES = new Set([
  'Internal SE',
  'Leadership',
  'Technical User',
  'Sales'
]);

const normalizeEmail = (user) => String(
  user?.email
  || user?.user_email
  || user?.userEmail
  || user?.username
  || '',
).trim().toLowerCase();

const hasHelixOpsEmail = (user) => {
  const email = normalizeEmail(user);
  return Boolean(email) && email.endsWith(HELIXOPS_EMAIL_DOMAIN.toLowerCase());
};

export const canLoadEmployeeNavigator = (user) => {
  if (!user) {
    return false;
  }

  if (partnerRoleService.isAdminUser(user)) {
    return true;
  }

  if (!hasHelixOpsEmail(user)) {
    return false;
  }

  const typeOfUser = String(user.typeOfUser || '').trim();
  return EMPLOYEE_NAVIGATOR_HELIX_USER_TYPES.has(typeOfUser);
};
